import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { isEmpty as _isEmpty } from 'lodash'

import EmptyState from 'components/Shared/EmptyState'
import Loading from 'components/Shared/Loading'

import {
  getOrganizations,
  updateOrganizationName,
  fetchOrganizations,
  getCurrentOrganization,
} from 'ducks/organizations'
import { useFunnelTracking } from 'hooks/useFunnelTracking'

import UsageSection from './UsageSection'
import FreePlanFlow from './FreeFlowSection'
import PlanAndServices from './BillingSection/PlansAndServices'
import PaymentMethods from './BillingSection/PaymentMethods'

const BillingSub = props => {
  const { organization, onReload, appId } = props

  if (_isEmpty(organization)) {
    return null
  }

  if (!organization.active) {
    return (
      <div className="team-settings-sub-free">
        <FreePlanFlow />
        <UsageSection organization={organization} appId={appId} />
      </div>
    )
  }

  const showUsageSection = organization.planType !== 'trial'

  const isTCIHandled = useMemo(() => {
    // Note @dancunhac: temporary disable TCI handling
    // return TRANSCOSMOS_REGIONS.includes(organization?.region)
    return false
  }, [organization?.region])

  return (
    <div className="team-settings-sub">
      {showUsageSection && (
        <UsageSection organization={organization} appId={appId} />
      )}
      <h3 className="settings-header">Billing</h3>
      <div className="settings-content-box">
        <PlanAndServices organization={organization} />
        {!isTCIHandled && (
          <>
            <hr />
            <PaymentMethods organization={organization} onSuccess={onReload} />
          </>
        )}
      </div>
    </div>
  )
}

const Billing = ({ fetchOrganizations, flags, currentOrganization, match }) => {
  const { trackViewedBillingTab } = useFunnelTracking()

  const fetchData = () => {
    fetchOrganizations()
  }

  useEffect(() => {
    fetchData()

    // Track billing tab access
    if (currentOrganization?.id) {
      trackViewedBillingTab(currentOrganization.id).catch(error => {
        console.error('Failed to track billing tab view:', error)
      })
    }
  }, [currentOrganization?.id, trackViewedBillingTab])

  const {
    params: { appId },
  } = match

  const org = currentOrganization

  return (
    <div className="team-settings">
      {org ? (
        [
          <BillingSub
            key={org.id}
            organization={org}
            updateOrganizationName={updateOrganizationName}
            onReload={fetchData}
            flags={flags}
            appId={appId}
          />,
        ]
      ) : (
        <EmptyState className="usage-section">
          <Loading />
        </EmptyState>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  organizations: getOrganizations(state),
  currentOrganization: getCurrentOrganization(state),
})

export default connect(mapStateToProps, {
  updateOrganizationName,
  fetchOrganizations,
})(Billing)
